<template>
  <b-container fluid class="editProject">
    <b-row>
      <b-col>
        <div class="text-left text-uppercase title p-3">
          <i class="material-icons smallIcon" v-on:click="goBack">arrow_back_ios</i>
          Edit Project
        </div>
      </b-col>
    </b-row>
    <b-row class="m-4" v-if="editingProject != null && editingProject.attributes != null">
      <b-col lg="3" md="3" sm="12" xs="12" class="box text-left questionBox">
        Project Name
      </b-col>
      <b-col lg="9" md="9" sm="12" xs="12" class="box text-left answerBox">
        <input type="text" placeholder="Project Name" v-model="editingProject.attributes.name">
      </b-col>
      <b-col lg="3" md="3" sm="12" xs="12" class="box text-left questionBox">
        City
      </b-col>
      <b-col lg="9" md="9" sm="12" xs="12" class="box text-left answerBox">
        <input type="text" placeholder="City" v-model="editingProject.attributes.city">
      </b-col>
      <b-col lg="3" md="3" sm="12" xs="12" class="box text-left questionBox">
        Description
      </b-col>
      <b-col lg="9" md="9" sm="12" xs="12" class="box text-left answerBox">
        <input type="text" placeholder="Description" v-model="editingProject.attributes.description">
      </b-col>
      <b-col lg="3" md="3" sm="12" xs="12" class="box text-left questionBox">
        Image
      </b-col>
      <b-col lg="9" md="9" sm="12" xs="12" class="box text-left answerBox">
        <img v-if="editingProject.attributes.images.data.length > 0" :src="getImage(editingProject.attributes.images.data[0].attributes.url, 'url')" style="width: 500px;">
      </b-col>
      <b-col lg="3" md="3" sm="12" xs="12" class="box text-left questionBox">
        Change Image
      </b-col>
      <b-col lg="9" md="9" sm="12" xs="12" class="box text-left answerBox">
        <input type="file" multiple :name="projectImage" :disabled=false
          @change="filesChange($event.target.name, $event.target.files[0]); fileCount = $event.target.files.length"
          accept="image/*">
      </b-col>
      <b-col lg="12" md="12" sm="12" xs="12" class="submitBtn text-left mt-5">
        <div class="p-3 text-center text-uppercase" v-on:click="editProject(editingProject)">
          Edit
        </div>
      </b-col>
    </b-row>
</b-container>
</template>

<script>
import util from '@/util'
import {mapGetters} from 'vuex'

export default {
  name: 'EditProject',
  data () {
    return {
      isLoading: false,
      errors: [],
      image: null,
      projectImage: {}
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    filesChange (filename, file) {
      this.$data.image = file
    },
    findProjectById (id) {
      this.$data.isLoading = true
      this.$store.dispatch('findProjectById', {
        data: {
          id: id
        },
        success: () => {
        },
        fail: () => {
          this.toast('Something went wrong. Try again later.', 'error', 'error_outline')
          console.log('failed get project by id')
          this.$router.push('/dprojects')
        }
      }).then(() => {
        this.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    editProject (project) {
      if (this.validateProject(project)) {
        this.$store.dispatch('editProject', {
          data: {
            id: project.id,
            project: {
              name: project.attributes.name,
              city: project.attributes.city,
              description: project.attributes.description
            },
            token: this.$cookies.get('a').jwt
          },
          success: (res) => {
            if (this.$data.image != null) {
              this.uploadFile(project.id, this.$data.image)
              const deleteImageId = project.attributes.images.data[0].id
              this.deleteFile(deleteImageId)
            }
            this.toast('Edit success.', 'success', 'check')
            this.$router.push('/dprojects')
          },
          fail: () => {
            this.toast('Edit failed. Try again later.', 'error', 'error_outline')
          }
        })
      } else {
        this.toast(this.$data.errors[0], 'error', 'error_outline')
        this.isLoading = false
      }
    },
    deleteFile (id) {
      this.$store.dispatch('deleteFile', {
        data: {
          id: id,
          token: this.$cookies.get('a').jwt
        },
        success: (res) => {
        },
        fail: () => {
          this.toast('Image upload failed.', 'error', 'error_outline')
        }
      }).then(() => {
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    uploadFile (id, files) {
      const fileToUpload = {
        files: files,
        refId: id,
        ref: 'api::dsk-project.dsk-project',
        field: 'images'
      }
      this.$store.dispatch('uploadFile', {
        data: {
          file: fileToUpload,
          token: this.$cookies.get('a').jwt
        },
        success: (res) => {
        },
        fail: () => {
          this.toast('Image upload failed.', 'error', 'error_outline')
        }
      }).then(() => {
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    validateProject (project) {
      if (project.attributes.name === '' || project.attributes.name.trim() === '' ||
          project.attributes.city === '' || project.attributes.city.trim() === '' ||
          project.attributes.description === '' || project.attributes.city.trim() === '') {
        this.$data.errors.push('Semua kolom wajib diisi')
        return false
      }
      return true
    },
    getImage (imageName, section) {
      return util.getImage(imageName, section)
    },
    toast (msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      })
    }
  },
  created () {
    this.findProjectById(this.$route.params.id)
  },
  computed: {
    ...mapGetters([
      'editingProject'
    ])
  }
}
</script>

<style scoped>
.editProject {
  height: 100vh;
}
.title {
  border-bottom: 1px solid #ccc;
}
.box {
  margin-bottom: 10px;
}
.box input {
  outline: none;
  width: 100%;
}
.submitBtn {
  background-color: #FF8F00;
  color: #fff;
  -webkit-transition: 300ms ease-in;
  -moz-transition: 300ms ease-in;
  -o-transition: 300ms ease-in;
  transition: 300ms ease-in;
}
.submitBtn:hover {
  background-color: #FFA000;
  color: #000;
  cursor: pointer;
}
.questionBox {
  padding-left: 0px;
  padding-right: 0px;
}
.answerBox {
  border-bottom: 1px solid #000;
}
.answerBox input {
  border: none;
}
.smallIcon {
  font-size:1em;
}
.smallIcon:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/EditProject.vue